"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDevelopmentsState = void 0;
var EnquireApiToken_1 = require("@/api/remote/protected/EnquireApiToken");
var EnquireState_init_1 = require("@/pages/common/states/EnquireState.init");
exports.defaultDevelopmentsState = {
    t: {
        orContactUsToday: 'or call us today at',
        markeingEmail: 'marketing@okay.com',
        telephone: '2102 0888',
        telephoneFull: '+85221020888',
        nameDeveloper: 'Developer',
        nameNewDevelopments: 'New Developments',
        prev: 'Previous',
        next: 'Next',
        bannerTitle: 'New Developments',
        bannerCaption: 'Looking for your dream home? You\'ve come to the right place.',
        cardPopupMore: 'More Info',
    },
    contactType: EnquireApiToken_1.EnquireRequestType.Firsthand_Properties,
    background: './res/img/masked.jpg',
    isLoading: EnquireState_init_1.defaultEnquireState.isLoading,
    pageNumber: 1,
    pageTotal: 3,
    pageSize: 6,
    projects: [
        {
            developmentId: 1,
            parentDevelopmentId: 0,
            districtId: 77,
            displayKey: 'mount-pokfulam',
            developmentName: 'MOUNT POKFULAM',
            createdDate: '7/13/2018 5:02:53 PM',
            updatedDate: '7/13/2018 5:02:53 PM',
            metas: [
                {
                    id: 5,
                    name: 'District',
                    text: 'SAI KUNG / CLEAR WATER BAY',
                },
            ],
            developers: [
                {
                    developerId: 1,
                    developerName: 'Wang On Properties, Wang On Properties, Wang On Properties',
                },
            ],
            developer: "Wang On Properties",
            address: "86A-86G Pok Fu Lam Road",
            addresses: [
                {
                    addressId: 1,
                    countryName: 'Hong Kong',
                    iso: 'HK',
                    streetNumber: '86A-86G',
                    route: 'Pok Fu Lam Road',
                    thoroughfare: '86A-86G Pok Fu Lam Road',
                    premise: null,
                    localityName: 'Hong Kong Island',
                    postalCode: null,
                    administrativeArea: 'Hong Kong Island',
                    dependentLocalityName: null,
                    latitude: 22.3862024,
                    longitude: 114.2719021,
                    googlePlaceId: 'ChIJbVebH5cFBDQR_r2d-W5wVm4',
                },
            ],
            developmentAssets: [
                {
                    assetId: 1,
                    assetName: 'Image1',
                    fileLocation: '/NewProperty/mount-pokfulam/',
                    resourceText: 'mount-pokfulam-terrace-landingpage',
                    fileExtension: 'webp',
                    categoryId: 999,
                    sort: 1,
                    purposeFlag: 3,
                },
                {
                    assetId: 1,
                    assetName: 'Image1',
                    fileLocation: '/NewProperty/mount-pokfulam/',
                    resourceText: 'mount-pokfulam-logo',
                    fileExtension: 'jpg',
                    categoryId: 999,
                    sort: 1,
                    purposeFlag: 4,
                },
            ],
        },
        {
            developmentId: 1,
            parentDevelopmentId: 0,
            districtId: 77,
            displayKey: 'victoria-coast',
            developmentName: 'VICTORIA COAST',
            createdDate: '7/13/2018 5:02:53 PM',
            updatedDate: '7/13/2018 5:02:53 PM',
            metas: [
                {
                    id: 5,
                    name: 'District',
                    text: 'SAI KUNG / CLEAR WATER BAY',
                },
            ],
            developers: [
                {
                    developerId: 1,
                    developerName: 'Sino Group',
                },
            ],
            developer: "Wang On Properties",
            address: "",
            addresses: [
                {
                    addressId: 1,
                    countryName: 'Hong Kong',
                    iso: 'HK',
                    streetNumber: '8',
                    route: 'Tai Mong Tsai Road',
                    thoroughfare: '8 Tai Mong Tsai Road',
                    premise: null,
                    localityName: 'Sai Kung',
                    postalCode: null,
                    administrativeArea: 'New Territories',
                    dependentLocalityName: null,
                    latitude: 22.3862024,
                    longitude: 114.2719021,
                    googlePlaceId: 'ChIJbVebH5cFBDQR_r2d-W5wVm4',
                },
            ],
            developmentAssets: [
                {
                    assetId: 1,
                    assetName: 'Image1',
                    fileLocation: '/NewProperty/victoria-coast/',
                    resourceText: 'victoria-coast-logo',
                    fileExtension: 'jpg',
                    categoryId: 999,
                    sort: 1,
                    purposeFlag: 4,
                }
            ],
        },
        {
            developmentId: 1,
            parentDevelopmentId: 0,
            districtId: 77,
            displayKey: 'high-peak',
            developmentName: 'HIGH PEAK',
            createdDate: '7/13/2018 5:02:53 PM',
            updatedDate: '7/13/2018 5:02:53 PM',
            metas: [
                {
                    id: 5,
                    name: 'District',
                    text: 'SAI KUNG / CLEAR WATER BAY',
                },
            ],
            developers: [
                {
                    developerId: 1,
                    developerName: 'Sino Group',
                },
            ],
            developer: "Wang On Properties",
            address: "",
            addresses: [
                {
                    addressId: 1,
                    countryName: 'Hong Kong',
                    iso: 'HK',
                    streetNumber: '8',
                    route: 'Tai Mong Tsai Road',
                    thoroughfare: '8 Tai Mong Tsai Road',
                    premise: null,
                    localityName: 'Sai Kung',
                    postalCode: null,
                    administrativeArea: 'New Territories',
                    dependentLocalityName: null,
                    latitude: 22.3862024,
                    longitude: 114.2719021,
                    googlePlaceId: 'ChIJbVebH5cFBDQR_r2d-W5wVm4',
                },
            ],
            developmentAssets: [
                {
                    assetId: 1,
                    assetName: 'Image1',
                    fileLocation: '/NewProperty/high-peak/',
                    resourceText: 'high-peak-logo',
                    fileExtension: 'jpg',
                    categoryId: 999,
                    sort: 1,
                    purposeFlag: 4,
                }
            ],
        },
        {
            developmentId: 1,
            parentDevelopmentId: 0,
            districtId: 77,
            displayKey: 'ansaldo',
            developmentName: 'ANSALDO',
            createdDate: '7/13/2018 5:02:53 PM',
            updatedDate: '7/13/2018 5:02:53 PM',
            metas: [
                {
                    id: 5,
                    name: 'District',
                    text: 'SAI KUNG / CLEAR WATER BAY',
                },
            ],
            developers: [
                {
                    developerId: 1,
                    developerName: 'Sino Group',
                },
            ],
            developer: "Wang On Properties",
            address: "",
            addresses: [
                {
                    addressId: 1,
                    countryName: 'Hong Kong',
                    iso: 'HK',
                    streetNumber: '8',
                    route: 'Tai Mong Tsai Road',
                    thoroughfare: '8 Tai Mong Tsai Road',
                    premise: null,
                    localityName: 'Sai Kung',
                    postalCode: null,
                    administrativeArea: 'New Territories',
                    dependentLocalityName: null,
                    latitude: 22.3862024,
                    longitude: 114.2719021,
                    googlePlaceId: 'ChIJbVebH5cFBDQR_r2d-W5wVm4',
                },
            ],
            developmentAssets: [
                {
                    assetId: 1,
                    assetName: 'Image1',
                    fileLocation: '/NewProperty/ansaldo/',
                    resourceText: 'ansaldo-logo',
                    fileExtension: 'jpg',
                    categoryId: 999,
                    sort: 1,
                    purposeFlag: 4,
                }
            ],
        },
        {
            developmentId: 1,
            parentDevelopmentId: 0,
            districtId: 77,
            displayKey: 'one-stanley',
            developmentName: 'ONE STANLEY',
            createdDate: '7/13/2018 5:02:53 PM',
            updatedDate: '7/13/2018 5:02:53 PM',
            metas: [
                {
                    id: 5,
                    name: 'District',
                    text: 'SAI KUNG / CLEAR WATER BAY',
                },
            ],
            developers: [
                {
                    developerId: 1,
                    developerName: 'Sino Group',
                },
            ],
            developer: "Wang On Properties",
            address: "",
            addresses: [
                {
                    addressId: 1,
                    countryName: 'Hong Kong',
                    iso: 'HK',
                    streetNumber: '8',
                    route: 'Tai Mong Tsai Road',
                    thoroughfare: '8 Tai Mong Tsai Road',
                    premise: null,
                    localityName: 'Sai Kung',
                    postalCode: null,
                    administrativeArea: 'New Territories',
                    dependentLocalityName: null,
                    latitude: 22.3862024,
                    longitude: 114.2719021,
                    googlePlaceId: 'ChIJbVebH5cFBDQR_r2d-W5wVm4',
                },
            ],
            developmentAssets: [
                {
                    assetId: 1,
                    assetName: 'Image1',
                    fileLocation: '/NewProperty/one-stanley/',
                    resourceText: 'one-stanley-logo',
                    fileExtension: 'jpg',
                    categoryId: 999,
                    sort: 1,
                    purposeFlag: 4
                }
            ],
        },
        {
            developmentId: 1,
            parentDevelopmentId: 0,
            districtId: 77,
            displayKey: 'solace',
            developmentName: 'SOLACE',
            createdDate: '7/13/2018 5:02:53 PM',
            updatedDate: '7/13/2018 5:02:53 PM',
            metas: [
                {
                    id: 5,
                    name: 'District',
                    text: 'SAI KUNG / CLEAR WATER BAY',
                },
            ],
            developers: [
                {
                    developerId: 1,
                    developerName: 'Sino Group',
                },
            ],
            developer: "Wang On Properties",
            address: "",
            addresses: [
                {
                    addressId: 1,
                    countryName: 'Hong Kong',
                    iso: 'HK',
                    streetNumber: '8',
                    route: 'Tai Mong Tsai Road',
                    thoroughfare: '8 Tai Mong Tsai Road',
                    premise: null,
                    localityName: 'Sai Kung',
                    postalCode: null,
                    administrativeArea: 'New Territories',
                    dependentLocalityName: null,
                    latitude: 22.3862024,
                    longitude: 114.2719021,
                    googlePlaceId: 'ChIJbVebH5cFBDQR_r2d-W5wVm4',
                },
            ],
            developmentAssets: [
                {
                    assetId: 1,
                    assetName: 'Image1',
                    fileLocation: '/NewProperty/solace/',
                    resourceText: 'solace-logo',
                    fileExtension: 'jpg',
                    categoryId: 999,
                    sort: 1,
                    purposeFlag: 4,
                }
            ],
        }
    ],
};
